<template>
    <section class="gmp-section gmp-mb-l">
        <div class="subpage-hero subpage-hero--no-padding">
            <div class="two-column-tout two-column-tout--fullbleed">
                <div class="two-column-tout__side">
                    <div class="two-column-tout__half-page two-column-tout__half-page--left">
                        <div class="two-column-tout__half-grid two-column-tout__half-grid--left">
                            <div class="two-column-tout__col">
                                <h1 class="h-c-headline h-c-headline--display-two">
                                    增强品牌竞争力
                                </h1>
                                <h2 class="h-u-mb-std two-column-tout__description">
                                    统一的品牌形象：通过“时鲜管理”等小程序，总部可以更好地管理各个加盟店的运营，确保每个门店都能提供一致的服务和菜品质量，从而增强品牌形象。
                                    创新和发展：小程序为加盟店提供了灵活的运营工具，使其能够更快地引入新菜品、优化菜单结构，并根据市场需求进行创新，提升市场竞争力。
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="two-column-tout__side">
                    <div class="two-column-tout__image two-column-tout__image--right">
                        <picture>
                            <img src="@/assets/img/jiamengBe.png" alt="The finer points." class="gmp-no-grab " >
                        </picture>
                    </div>
                </div>

            </div>

        </div>



    </section>
</template>

<script>
    export default {
        name: "FS_two_column_fullbleed"
    }
</script>

<style lang="less">
h2{
    font-size: 18px;
    font-weight: 300;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

</style>